module.exports = __webpack_public_path__ + "media/img/career_starter_en-064b8caa2e2c2380be1be5b3e0055255.jpg";